/**
 * Calculates FSS-score or total filled fields for historyview
 */

import { values, sum, is, forEach, defaultTo } from 'ramda';
import sectionsFSS from './FSSSections';
import { getLatestCommitData } from 'lib/documentHandling';

// Calculate FSS-score
export default sections => {
  const score = Math.round((sum(values(sections)) / values(sections).length) * 10) / 10;
  return is(Number, score) && score > 0 ? score : null;
};

// Calculate total filled fields per document
export const calculateFSSTotals = d => {
  for (let i = 0; i < d.length; i++) {
    d[i] = {
      ...d[i],
      filled: 0,
    };
    forEach(s => {
      let value = safelyHandleValue(getLatestCommitData(d[i]), s);
      if (value) {
        d[i].filled++;
      }
    }, sectionsFSS);
  }
  return d;
};

const safelyHandleValue = (obj, val) => defaultTo(null, obj[val]);
